// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconSignout: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="11" viewBox="0 0 12 11" fill="currentColor">
            <path
                fill="currentColor"
                d="M373.889843,818.985156 L370.514843,815.610157 C370.368359,815.463672 370.130937,815.463672 369.984687,815.610157 C369.838438,815.756641 369.838203,815.994062 369.984687,816.140313 L372.720312,818.875 L366.125,818.875 C365.91875,818.875 365.75,819.04375 365.75,819.25 C365.75,819.45625 365.917719,819.625 366.125,819.625 L372.720312,819.625 L369.985157,822.360157 C369.838672,822.506641 369.838672,822.744063 369.985157,822.890313 C370.131641,823.036562 370.369063,823.036797 370.515313,822.890313 L373.890313,819.515313 C373.9625,819.442188 374,819.346094 374,819.25 C374,819.153906 373.9625,819.057813 373.889843,818.985156 Z M366.125,823.75 L363.875,823.75 C363.254609,823.75 362.75,823.246094 362.75,822.625 L362.75,815.875 C362.75,815.254609 363.254609,814.75 363.875,814.75 L366.125,814.75 C366.33125,814.75 366.5,814.582187 366.5,814.375 C366.5,814.167813 366.33125,814 366.125,814 L363.875,814 C362.840938,814 362,814.840938 362,815.875 L362,822.625 C362,823.658594 362.840938,824.5 363.875,824.5 L366.125,824.5 C366.33125,824.5 366.5,824.33125 366.5,824.125 C366.5,823.91875 366.33125,823.75 366.125,823.75 Z"
                transform="translate(-362 -814)"
            />
        </svg>
    );
};

export default React.memo(IconSignout);
